export const APP_CONSTANTS = {
    API_PREFIX: '/api',
    LOGIN_SSO_PATH: '/login/sso',
    LOGIN_SSO_SWITCH_ACCOUNT_PATH: '/login/sso/switch-account'
} as const;
